import { Link } from "react-router-dom";
import { UserPlus, ArrowRight } from "lucide-react";

export default function BewerbenCTA({ stadtName, stadtSlug }) {
  return (
    <section className="py-14 bg-green-700" id={`bewerben-${stadtSlug}`} data-testid={`${stadtSlug}-bewerben`}>
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row md:items-center gap-6">
        <div className="flex-1">
          <p className="inline-flex items-center gap-2 text-green-100 text-sm font-semibold mb-2"><UserPlus className="h-4 w-4" />Wir suchen Verstärkung in {stadtName}</p>
          <h2 className="font-['Manrope'] text-2xl sm:text-3xl font-bold text-white">Alltagsbegleiter/in in {stadtName} werden</h2>
          <p className="text-green-50 mt-2 text-sm sm:text-base">Minijob oder Teilzeit, Einsätze wohnortnah, Einarbeitung und Schulung inklusive. Die Bewerbung dauert zwei Minuten – ohne Lebenslauf, wir rufen Sie zurück.</p>
        </div>
        <Link to={`/bewerbung/${stadtSlug}`} className="inline-flex items-center justify-center gap-2 h-14 px-7 rounded-2xl bg-white text-green-800 font-bold text-base shadow-lg hover:bg-green-50 transition-colors" data-testid={`${stadtSlug}-bewerben-button`}>
          Jetzt in {stadtName} bewerben<ArrowRight className="h-5 w-5" />
        </Link>
      </div>
    </section>
  );
}
